import service from '@/store/services/movimientos-service';
import Jsona from 'jsona';

const jsona = new Jsona();

export const state = () => ({
  list: {},
  meta: {},
  movimiento: {},
  url: null
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
  SET_RESOURCE: (state, movimiento) => {
    state.movimiento = movimiento;
  },
};

export const actions = {
  list({commit, dispatch}, params = {}) {
    return service.list(params, this.$axios)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  getMotivoIngreso({commit, dispatch}, params) {
    return service.getMotivoIngresos(params, this.$axios)
      .then((list) => { list });
  },

  getMotivoEgreso({commit, dispatch}, params) {
    console.log(service.getMotivoEgresos())
      return service.getMotivoEgresos();
  },

  addIngreso({commit, dispatch}, params) {
    return service.addIngreso(params, this.$axios)
      .then((movimiento) => { commit('SET_RESOURCE', movimiento); });
  },
  addEgreso({commit, dispatch}, params) {
    return service.addEgreso(params, this.$axios)
      .then((movimiento) => { commit('SET_RESOURCE', movimiento); });
  },
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.total, 
  getMotivoIngreso: state => state,
  getMotivoEgreso: state => state,
  addIngreso: state => state.movimiento,
  addEgreso: state => state.movimiento,
  movimiento: state => state.movimiento,
  url: state => state.url
};

const movimientos = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default movimientos;
